import { Component, OnInit } from '@angular/core';
import { Router } from "@angular/router";
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { PersonelService } from '../services/personel.service';
import { AuthService } from '../services/auth.service';
import { Personel, PersonelLogin, SignInDto } from '../models/Personel';
import { NotifymodalComponent } from '../notifymodal/notifymodal.component';
import { MatDialog } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {


  loginForm = new FormGroup({
    userName: new FormControl(''),
    password: new FormControl(''),
  });


  constructor(
    private router: Router,
    public personelService: PersonelService,
    private formBuilder: FormBuilder,
    private authService: AuthService,
    public dialog: MatDialog,
    private spinner: NgxSpinnerService,
  ) { }

  ngOnInit(): void {

    this.loginForm.controls["userName"].setValidators([Validators.minLength(11), Validators.maxLength(11), Validators.pattern("^[0-9]*$")]);

  }


  loginClick() {
    /*
    //login check
    this.personelService.checkPersonel(this.loginForm.value.userName,this.loginForm.value.password).subscribe(res => {
      console.log(res);
    });
*/

    let signinDto: SignInDto = {
      userName: this.loginForm.value.userName,
      password: this.loginForm.value.password,
    };

    this.spinner.show();

    this.personelService.userLogin(signinDto).subscribe(res => {

      
      //console.log("user:\n"+res);

      let personelLogin: PersonelLogin = {
        access_token: res.access_token,
        token_type: res.token_type,
        user_name: res.user_name,
        user_role: res.user_role,
        first_login: res.first_login,
      }

      this.authService.login(personelLogin);

      this.spinner.hide();

      if(personelLogin.first_login == "True"){
        this.router.navigate(['dashboard/sifreDegistir']);
      }else{
        this.router.navigate(['dashboard']);
      }
    },
      error => {
        this.spinner.hide();
        this.dialog.open(NotifymodalComponent, {
          data: {
            isSuccess: false,
            text: error.error.error,
            subject: "Hatalı Giriş"
          }
        });
      });

    /*
        //test için 
        this.authService.loginTest();
        this.router.navigate(['dashboard']);
    */
    //this.router.navigate(['dashboard']);
    //this.loginForm.value.userName
    //console.log(this.loginForm.get('userName').errors.required == null );
    //console.log(this.loginForm.value.userName +  "/"+this.loginForm.value.password);

    if ((this.loginForm.get('password').errors?.required == null ||
      this.loginForm.get('userName').errors?.required == null) &&
      !this.loginForm.get('userName').errors?.minlength &&
      !this.loginForm.get('password').errors?.minlength &&
      !this.loginForm.get('password').errors?.pattern) {

      //login ok access token ı kaydet

    }

    //console.log(this.loginForm.value);
    /*
        if(this.loginForm.invalid){
          return;
        }
        this.authService.login(this.loginForm.value);
        this.router.navigateByUrl('/admin');
    */
  }

  get name() { return this.loginForm.get('userName'); }

  get power() { return this.loginForm.get('password'); }

}
